"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'share.conversation.loading': 'Caricamento conversazione...',
    'share.conversation.noIdProvided': 'Nessun ID conversazione fornito',
    'share.conversation.failedToLoad': 'Impossibile caricare la conversazione',
    'share.conversation.untitled': 'Conversazione senza titolo',
    'share.conversation.linkCopied': 'Link copiato negli appunti',
    'share.conversation.linkCopyFailed': 'Impossibile copiare il link',
    'share.conversation.copyLink': 'Copia link',
    'share.conversation.goToChat': 'Vai alla chat',
    'share.conversation.you': 'Tu',
    'share.conversation.assistant': 'Assistente',
    'share.conversation.reasoning': 'Ragionamento',
    'share.conversation.thoughts': 'Pensieri',
    'share.conversation.sources': 'Fonti',
    'share.conversation.toolsUsed': 'Strumenti utilizzati',
    'share.conversation.noMessages': 'Nessun messaggio trovato',
    'share.conversation.noMessagesDescription': 'Questa conversazione sembra essere vuota o i messaggi non possono essere caricati.',
    'share.conversation.footerNote': 'Questa è una conversazione condivisa. Puoi iniziare la tua chat per interagire con l\'IA.',
    'share.conversation.startNewChat': 'Inizia nuova chat',
    'share.conversation.unknownModel': 'Modello sconosciuto',
};
